export default __webpack_public_path__ + "static/media/motherEight.b0bacfac.jpeg";